import {
  AnalyticsActions,
  BaseProps,
  Events,
  handOffBagsAndDrinksInputProps,
} from './core';

function whenHandOffBagsAndDrinksInput(
  { orderId }: BaseProps,
  params: handOffBagsAndDrinksInputProps,
) {
  const args = {
    [Events.handOffBagsAndDrinksInput.props.orderId]: orderId,
    [Events.handOffBagsAndDrinksInput.props.numberOfBags]: params.numberOfBags,
    [Events.handOffBagsAndDrinksInput.props.outsideDrink]: params.outsideDrink,
    [Events.handOffBagsAndDrinksInput.props.orderState]: params.orderState,
  };
  AnalyticsActions.logHandOffBagsAndDrinksInput(args);
}

export const OrderDeliveryDetailAnalytics = {
  whenHandOffBagsAndDrinksInput,
};
